export enum AddressChangeStatus {
  START_PREMIUM = 'START_PREMIUM',
  CONTINUE = 'CONTINUE',
  START_STANDALONE = 'START_STANDALONE',
  NOT_ELIGIBLE_USED_MP = 'NOT_ELIGIBLE_USED_MP',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

export type AddressChangeStatusRes = {
  status: AddressChangeStatus;
};
